export default __webpack_public_path__ + "static/media/automatic-printing.dcd2fee8.svg";